import { AsyncPipe, DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { SubReservationApiModel } from '@era/inroom-sdk';
import { Store } from '@ngrx/store';
import { isNotUndefined } from '@rocksoft/shared';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { selectCurrentMobileReservation } from '../../../stores/mobilereservation/mobilereservation.selector';

@Component({
  selector: 'era-reservation-summary',
  templateUrl: './reservation-summary.container.html',
  imports: [AsyncPipe, DatePipe],
})
export class ReservationSummaryContainerComponent {
  private readonly store = inject(Store);

  public readonly reservation$: Observable<SubReservationApiModel>;

  constructor() {
    this.reservation$ = this.store.select(selectCurrentMobileReservation).pipe(
      map((x) => x?.SubReservations?.[0]),
      filter(isNotUndefined)
    );
  }
}
